module.exports = __webpack_public_path__ + "img/mlogo.ecdef061.svg";